export default "__VITE_ASSET__864956ab__"